const MANUAL_DG_TYPES = ['CS', 'CA', 'PA']

const MANUAL_AFTER_SALE_REASONS = [
  { id: 'DAMAGED_REJECTED', name: '商品破損已拒簽' },
  { id: 'NOT_RECEIVED', name: '快遞／物流一直未送到' },
  { id: 'EMPTY_PARCEL', name: '空包裹' },
  { id: 'WRONG_SPEC', name: '訂單資訊有誤（規格／尺寸／顏色等）' },
  { id: 'AGREED_REFUND', name: '協商一致退款' },
  { id: 'OUT_OF_STOCK', name: '缺貨' },
  { id: 'NOT_AS_DESCRIBED', name: '顏色／款式／大小／尺寸與描述不符' },
  { id: 'QUALITY_ISSUE', name: '品質問題' },
  { id: 'MISSING_ITEMS', name: '少件（含缺少配件）' },
  { id: 'WRONG_ITEM', name: '賣家發錯貨' },
  { id: 'NO_LONGER_NEEDED', name: '不想要了' },
]

const DGORDER_STATUS_TEXT = {
  100: '已下單',
  300: '採購中',
  500: '已採購',
  700: '已發貨',
  800: '已收貨',
  900: '已完成',
}

const DGORDER_AFTER_SALE_STATUS_TEXT = {
  100: '待處理',
  700: '已撤銷',
  800: '已同意退款',
  900: '已完成',
}

function findByValue (list, value, key) {
  if (!Array.isArray(list)) return null
  return list.find(item => String(item[key]) === String(value)) || null
}

function getReasonText (reasons, reasonId) {
  const reason = findByValue(reasons, reasonId, 'id') || findByValue(reasons, reasonId, 'reason_id')
  if (!reason) return reasonId || ''
  return reason.name || reason.reason_desc || reasonId || ''
}

function getGoodsStatusText (goodsStatusItems, goodsStatus) {
  const item = findByValue(goodsStatusItems, goodsStatus, 'value')
  return item ? item.text : goodsStatus || ''
}

function getSkuText (goods) {
  if (!goods || !Array.isArray(goods.skuInfos)) return ''
  return goods.skuInfos
    .map(item => item.value)
    .filter(Boolean)
    .join(' ')
}

function isManualDgType (dgType) {
  return MANUAL_DG_TYPES.includes(String(dgType || '').toUpperCase())
}

function isManualDgorder (order) {
  return !!order && isManualDgType(order.dgType)
}

// 保留旧名称，避免其它调用方在迁移期间失效。
function isCsDgorder (order) {
  return isManualDgorder(order)
}

function canSubmitAliRefundDirectly (order, isRefundWaitSellerSendAllItems) {
  return !isManualDgorder(order) && !!isRefundWaitSellerSendAllItems
}

function getManualGoodsState (order, goods) {
  const dgStatus = Number(order && order.dgStatus)
  if (dgStatus >= 800) return 'received'
  if ((goods && goods.gsMailNo) || dgStatus >= 700) return 'shipped'
  return 'unshipped'
}

function getManualGoodsStatus (order, goods) {
  const state = getManualGoodsState(order, goods)
  if (state === 'received') {
    return {
      state,
      status: 'success',
      statusStr: dgStatusText(order && order.dgStatus),
      allowApplyStatus: ['aftersaleBuyerReceived'],
    }
  }
  if (state === 'shipped') {
    return {
      state,
      status: 'waitbuyerreceive',
      statusStr: '已發貨',
      allowApplyStatus: ['aftersaleBuyerNotReceived'],
    }
  }
  return {
    state,
    status: 'waitsellersend',
    statusStr: '未發貨',
    allowApplyStatus: ['refundWaitSellerSend'],
  }
}

function toPositiveNumber (value, fallback = 0) {
  const number = Number(value)
  return Number.isFinite(number) && number > 0 ? number : fallback
}

function goodsUnitAmount (goods) {
  if (!goods) return 0
  return toPositiveNumber(goods.gsAmtCNY, toPositiveNumber(goods.gsPrice))
}

function toCent (amount) {
  return Math.round(toPositiveNumber(amount) * 100)
}

function buildManualAliRefundPreview (order) {
  const goodsList = Array.isArray(order && order.goods) ? order.goods : []
  const productItems = goodsList.map((goods, index) => {
    const quantity = toPositiveNumber(goods.gsQty, 1)
    const unitAmount = goodsUnitAmount(goods)
    const status = getManualGoodsStatus(order, goods)
    const subItemIDString = String(
      (goods.gsExtras && goods.gsExtras.subItemIDStr) ||
      goods.gsid ||
      `${order && order.dgid ? order.dgid : 'manual'}-${index}`
    )

    return {
      subItemIDString,
      productImgUrl: Array.isArray(goods.gsImgs) ? goods.gsImgs : [],
      name: goods.gsTitle || '',
      skuInfos: (goods.gsExtras && goods.gsExtras.skuInfos) || [],
      quantity,
      price: toCent(unitAmount),
      itemAmount: toCent(unitAmount * quantity),
      status: status.status,
      statusStr: status.statusStr,
      allowApplyStatus: status.allowApplyStatus,
    }
  })
  const shippingFee = toPositiveNumber(order && order.dgOrderPostFee)

  return {
    manual: true,
    orderid: (order && (order.dgOrderid || order.dgid)) || '',
    productItems,
    shippingFee,
    refundableShippingFee: shippingFee,
  }
}

function getManualAliRefundReasons () {
  return MANUAL_AFTER_SALE_REASONS.map(item => ({ ...item }))
}

function getManualTaobaoRefundReasons () {
  return MANUAL_AFTER_SALE_REASONS.map(item => ({
    reason_id: item.id,
    reason_desc: item.name,
  }))
}

function getManualTaobaoGoodsStatus (order, goods) {
  const state = getManualGoodsState(order, goods)
  if (state === 'received') return '4'
  if (state === 'shipped') return '3'
  return '1'
}

function canManualOrderReturnGoods (order, goods) {
  return getManualGoodsState(order, goods) === 'received'
}

function buildManualTaobaoRefundPreview (order, goods) {
  const quantity = toPositiveNumber(goods && goods.gsQty, 1)
  const maxRefundFee = toCent(goodsUnitAmount(goods) * quantity)
  const goodsStatus = Number(getManualTaobaoGoodsStatus(order, goods))
  const refundReasons = getManualTaobaoRefundReasons()

  return {
    manual: true,
    dgType: order && order.dgType,
    refund_order_template: {
      max_refund_fee: {
        max_refund_fee: maxRefundFee,
        refund_fee: maxRefundFee,
        can_edit_refund_fee: true,
      },
      refund_order: {
        goods_status: goodsStatus,
      },
      refund_reasons: refundReasons,
    },
  }
}

function dgStatusText (status) {
  return DGORDER_STATUS_TEXT[Number(status)] || '處理中'
}

function dgAfterSaleStatusText (status) {
  return DGORDER_AFTER_SALE_STATUS_TEXT[Number(status)] || '客服處理中'
}

function buildDgorderAfterSaleWorkOrderParams ({
  dgid,
  form,
  model,
  orderEntryIds,
  orderEntryCountMap,
  productItemsFilted,
  goodsStatusItems,
  reasons,
}) {
  const contentLines = [
    `代購售後 ${dgid} ${form.disputeRequest === 'refund' ? '僅退款' : '退貨退款'}`
  ]

  orderEntryIds.forEach(id => {
    const goods = productItemsFilted.find(item => item.subItemIDString === id)
    if (!goods) return

    const count = orderEntryCountMap[id]
    const skuText = getSkuText(goods)

    contentLines.push(goods.name)
    contentLines.push(`${skuText ? `${skuText} ` : ''}x ${count}`)
  })

  contentLines.push(`貨品情況: ${getGoodsStatusText(goodsStatusItems, form.goodsStatus)}`)
  contentLines.push(`申請原因: ${getReasonText(reasons, form.applyReasonId)}`)
  contentLines.push(`退款貨品金額: ￥${form.applyPayment}`)
  contentLines.push(`退款運費金額: ￥${form.applyCarriage}`)
  contentLines.push(model.content)

  return {
    ignoreLimit: '1',
    tag: 'dgorder',
    site: 'MG',
    title: '代購售後服務',
    upyunFiles: model.upyunFiles,
    content: contentLines.join('\n'),
  }
}

module.exports = {
  MANUAL_DG_TYPES,
  MANUAL_AFTER_SALE_REASONS,
  isManualDgType,
  isManualDgorder,
  isCsDgorder,
  canSubmitAliRefundDirectly,
  getManualGoodsState,
  buildManualAliRefundPreview,
  getManualAliRefundReasons,
  getManualTaobaoRefundReasons,
  getManualTaobaoGoodsStatus,
  canManualOrderReturnGoods,
  buildManualTaobaoRefundPreview,
  dgStatusText,
  dgAfterSaleStatusText,
  buildDgorderAfterSaleWorkOrderParams,
}
